import { ShipService } from './../../services/ship.service';
import { Ship } from './../../Ship';
import { MerchantService } from './../../services/merchant.service';
import { Identity } from './../../Identity';
import { Merchant } from './../../Merchant';
import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-merchant-details',
  templateUrl: './merchant-details.component.html',
  styleUrls: ['./merchant-details.component.css']
})
export class MerchantDetailsComponent implements OnInit {
  shipName = '';
  merchantName = '';
  showRecent = false;
  _merchant: Merchant;
  _identity: Identity;
  _merchants: Merchant[];
  ships: string[];

  @Input() set merchant(merchant: Merchant) {
    this._merchant = merchant;
    this.refreshMerchantDetails();
  }
  get merchant() {
    return this._merchant;
  }

  @Input() set identity(identity: Identity) {
    this._identity = identity;
    this.refreshMerchantDetails();
  }
  get identity() {
    return this._identity;
  }

  @Input() set merchants(merchants: Merchant[]) {
    this._merchants = merchants;
  }
  get merchants(): Merchant[] {
    return this._merchants.slice(-5);
  }

  img_src = '';
  headerTitle = '';
  headerText1 = '';
  headerText2 = '';

  constructor(
    private merchantService: MerchantService,
    private shipService: ShipService,
    private router: Router
  ) { }

  ngOnInit() {
    this.shipService.getShips().subscribe(
      (data: Ship[]) => {
        const someships = data;
        this.ships = someships.map(ship => {
          return ship.shipName;
        });
      },
      () => {
        console.log('There was an error fetching ship information.');
      }
    );
  }

  selectShip(ship: any) {
    this.shipName = ship.value;
  }

  refreshMerchantDetails() {
    if (this.merchant && this.identity) {
      let img = 'NAVY'; // Default to NAVY
      const milBranch = this.identity.militaryBranch;
      if (milBranch && milBranch.trim() !== '') {
        img = milBranch;
      }
      this.img_src = 'assets/img/' + img + '.png';
      this.headerTitle = this.merchant.descriptionLong;
      this.headerText1 =
        this.identity.currentShip.shipName +
        ' (' +
        this.merchant.location +
        ')';
      this.headerText2 = this.merchant.merchantType;
    }
  }

  selectMerchant(merchant: Merchant) {
    this.merchantService.selectMerchant(merchant);
    this.router.navigate(['/merchantProfiles/accounts']);
    this.showRecent = false;
  }

  searchMerchants() {
    if (this.merchantName.length > 0 || this.shipName.length > 0) {
      this.merchantService.clearPassedParams();
      if (this.shipName.length > 0) {
        this.merchantService.setPassedParam('selectedLocation', this.shipName);
      }
      if (this.merchantName.length > 0) {
        this.merchantService.setPassedParam('searchTerm', this.merchantName);
      }
      this.router.navigate(['/merchantProfiles']);
    }
  }
}
